import ButtonSort from '../../../../shared/ButtonSort';

const Header = ({
  mode,
  loadingUpdate,
  sortConfig,
  handleSort,
  stickyOffset,
}) => {
  if (mode === 'resume') return null;
  return (
    <thead className="bg-gray-50 sticky z-10" style={{ top: stickyOffset + 12 }}>
      <tr className="flex w-full">
        <th className="flex-[2] flex items-center px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
          Tipo
          {mode === 'principal' && !loadingUpdate && (
            <ButtonSort handleSort={handleSort} field="type" direction={sortConfig.direction} />
          )}
        </th>
        <th className="flex-[3] flex items-center px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
          Nombre
          {mode === 'principal' && !loadingUpdate && (
            <ButtonSort handleSort={handleSort} field="Name" direction={sortConfig.direction} />
          )}
        </th>
        {mode !== 'principal' && (
          <th className="flex-[1] px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
            Fecha de registro
          </th>
        )}
        <th className="flex-[1] flex items-center px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
          Puntaje
          {mode === 'principal' && !loadingUpdate && (
            <ButtonSort handleSort={handleSort} field="Score" direction={sortConfig.direction} />
          )}
        </th>
      </tr>
    </thead>
  );
};

export default Header;
